// extracted by mini-css-extract-plugin
export default {"button":"XcomButton_button__4N16r","consent-given":"XcomButton_consent-given__6BiBU","consent-refused":"XcomButton_consent-refused__z26VB"};